import styled from 'styled-components';
import { ReactComponent as RawFullscreenSVG } from '../../../../assets/icons/icon_fullscreen.svg';

export const IconFullscreen = styled(RawFullscreenSVG)``;
